import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const hireCards = [
  {
    name: "SDE",
    image : 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/users/Frame%2010995%20(1).png',
    position: "top-[40%] left-[27%]",
  },
  {
    name: "Data Analyst",
    image : 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/users/Frame%20427320891%20(1).png',
    position: "top-[33%] left-[66%]",
  },
  {
    name: "Cloud Engineer",
    image : 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/users/Frame%20427320892%20(1).png',
    position: "top-[76%] left-[44%]",
  },
  {
    name: "Product Manager",
    image : 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/users/Frame%20427320893%20(1).png',
    position: "top-0 left-[44%]",
  },
  {
    name: "DevOps Engineer",
    image : 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/users/Frame%20427320894%20(1).png',
    position: "top-[8%] left-0",
  },
  {
    name: "AI/ML Engineer",
    image : 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/users/Frame%20427320895%20(1).png',
    position: "top-[71%] left-0",
  },
];

const BottomScroll = () => {
  const scrollRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  useEffect(() => {
    if (!isMobile) return; // Only run auto-scroll on mobile

    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollPosition = 0;
    const scrollSpeed = 0.5;

    const scroll = () => {
      scrollPosition += scrollSpeed;

      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }

      scrollContainer.scrollLeft = scrollPosition;
      requestAnimationFrame(scroll);
    };

    const animationFrame = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrame);
  }, [isMobile]);

  const renderHireCard = (card, index) => (
    <div
      key={index}
      className={`inline-flex flex-col items-center gap-1.5 p-2 sm:p-3 absolute ${card.position} bg-[#406aff26] rounded-[12px_12px_0px_12px] border-0`}
    >
      <div className="p-0">
        <div className="inline-flex items-center gap-1.5 relative flex-[0_0_auto]">
          <div className="relative flex h-8 w-8 sm:h-10 sm:w-10 shrink-0 overflow-hidden rounded-full flex-[0_0_auto]">
            <img
              src={card.image}
              alt="Profile"
              className="aspect-square h-full w-full"
              width={32}
              height={32}
            />
          </div>

          <div className="flex flex-col w-20 sm:w-[100px] items-start gap-1 relative">
            <div className="relative self-stretch mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-transparent text-[10px] sm:text-xs tracking-[0] leading-tight sm:leading-[15.6px]">
              <span className="text-[#ffffff80]">
                Hired As <br />
              </span>

              <span className="font-medium text-white">
                {card?.name}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Mobile version (existing auto-scroll behavior)
  const renderMobileVersion = () => (
    <div className="flex flex-col w-full items-start relative overflow-hidden">
      <div
        ref={scrollRef}
        className="flex items-start gap-2.5 relative overflow-x-hidden scrollbar-hide whitespace-nowrap"
        style={{ width: '100%', msOverflowStyle: 'none', scrollbarWidth: 'none' }}
      >
        <div className="inline-flex relative min-w-full">
          <div className="relative w-full aspect-[16/9] md:aspect-[482/180]">
            {hireCards?.map(renderHireCard)}
          </div>
        </div>
        <div className="inline-flex relative min-w-full">
          <div className="relative w-full aspect-[16/9] md:aspect-[482/180]">
            {hireCards?.map(renderHireCard)}
          </div>
        </div>
      </div>
    </div>
  );

  // Desktop version (Swiper carousel)
  const renderDesktopVersion = () => (
    <div className="flex flex-col w-full justify-center items-start relative">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={8}
        slidesPerView={4.2}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        className="w-full"
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 8,
          },
          1024: {
            slidesPerView: 4.2,
            spaceBetween: 8,
          },
        }}
      >
        {hireCards?.map((card, index) => (
          <SwiperSlide key={index}>
            <div className="relative w-full h-[70px] flex items-center justify-center">
              <div className="h-full inline-flex flex-col items-center justify-center gap-1.5 p-2 bg-[#406aff26] rounded-[12px_12px_12px_12px] border-0 w-full">
                <div className="p-0 w-full">
                  <div className="inline-flex items-center gap-1.5 relative flex-[0_0_auto] w-full">
                    <div className="relative flex h-8 w-8 shrink-0 overflow-hidden rounded-full flex-[0_0_auto]">
                      <img
                        src={card.image}
                        alt="Profile"
                        className="aspect-square h-full w-full"
                        width={32}
                        height={32}
                      />
                    </div>

                    <div className="flex flex-col flex-1 items-start gap-1 relative min-w-0">
                      <div className="relative self-stretch mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-transparent text-xs tracking-[0] leading-tight">
                        <span className="text-[#ffffff80]">
                          Hired As <br />
                        </span>

                        <span className="font-medium text-white truncate block">
                          {card?.name}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );

  return isMobile ? renderMobileVersion() : renderDesktopVersion();
};


export default BottomScroll;